import { CardInfo } from '@/features/profile/ui/ProfileCard/CardInfo/CardInfo'
import { ProfileIcon } from '@/features/profile/ui/ProfileCard/ProfileIcon/ProfileIcon'
import { ProfileTabNames } from '@/pages/panel/Profile'
import { BaseCard } from '@/shared/components/BaseCard/BaseCard'
import { BaseTabs } from '@/shared/components/BaseTabs/BaseTabs'
import { OptionModel } from '@/shared/lib/types'

type Props = {
  setTabName: (value: 'info' | 'safe' | 'timeZone' | 'rate' | 'sessions') => void
  tabName: ProfileTabNames
}

const tabsButton: OptionModel[] = [
  { label: 'Личная информация', value: 'info', index: 0 },
  { label: 'Безопасность', value: 'safe', index: 1 },
  { label: 'Часовой пояс', value: 'timeZone', index: 2 },
  { label: 'Ставка', value: 'rate', index: 3 },
  { label: 'Сессии', value: 'sessions', index: 4 },
]

export const ProfileCard = ({ setTabName, tabName }: Props) => {
  return (
    <BaseCard
      className="flex flex-col flex-4 2xl:flex-4 xl:flex-1 gap-6 px-5 md:px-6 py-8 w-full"
      variant="secondary"
    >
      <CardInfo />
      <div className="flex flex-col w-full">
        <BaseTabs
          tabs={tabsButton}
          selectedTab={tabName}
          onSelect={setTabName}
          iconComponent={(name) => <ProfileIcon name={name} />}
        />
      </div>
    </BaseCard>
  )
}
